import { useEffect } from 'react';

// Small SEO helper, updates document title + primary meta tags on route change.
// No react-helmet dependency needed.
const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [, key] = selector.match(/\[(?:name|property)="([^"]+)"\]/) || [];
    const isProp = selector.includes('property=');
    if (key) el.setAttribute(isProp ? 'property' : 'name', key);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const BASE_URL = 'https://yellowagency.co.uk';
const DEFAULT_OG_IMAGE = `${BASE_URL}/assets/yellow-logo.png`;

const useSEO = ({ title, description, path = '', image }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
      setMeta('meta[name="twitter:description"]', 'content', description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', 'content', title);
      setMeta('meta[name="twitter:title"]', 'content', title);
    }
    const url = `${BASE_URL}${path}`;
    setMeta('meta[property="og:url"]', 'content', url);
    setLink('canonical', url);
    const ogImage = image || DEFAULT_OG_IMAGE;
    setMeta('meta[property="og:image"]', 'content', ogImage);
    setMeta('meta[name="twitter:image"]', 'content', ogImage);
  }, [title, description, path, image]);
};

export default useSEO;
